import { isEmpty } from 'lodash';
import { useSessionStorage } from 'usehooks-ts';

import { RecordsWithTimestamp } from '@app/components';
import {
  UserSearchDto,
  useSaveRecentInstancesMutation,
  useSaveRecentSearchesMutation,
} from '@app/hooks';
import { storageKeys } from '@app/constants';

export const useRecentActivityTransfer = () => {
  const [viewedInstances, setViewedRecords] = useSessionStorage<
    RecordsWithTimestamp[]
  >(storageKeys.viewedRecords, []);
  const [searchHistory, setSearchHistory] = useSessionStorage<UserSearchDto[]>(
    storageKeys.searchHistory,
    []
  );
  const transferViewedRecordsMutation = useSaveRecentInstancesMutation();
  const transferSearchesMutation = useSaveRecentSearchesMutation();

  const transferRecentActivity = (systemId: string) => {
    if (!isEmpty(viewedInstances)) {
      transferViewedRecordsMutation.mutate(
        {
          viewedInstances,
          systemId,
        },
        { onSuccess: () => setViewedRecords([]) }
      );
    }

    if (!isEmpty(searchHistory)) {
      transferSearchesMutation.mutate(
        {
          searches: searchHistory,
          systemId,
        },
        { onSuccess: () => setSearchHistory([]) }
      );
    }
  };

  return {
    isLoading:
      transferSearchesMutation.isLoading ||
      transferViewedRecordsMutation.isLoading,
    transfer: transferRecentActivity,
  };
};
